import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useLocationManagement } from './hooks';
import { SelectedLocationBase } from './selected_location';
const wrapperCss = "w1qw0hbo";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const LocationList = ({
  eventType,
  isDisabled,
  isLocked,
  isReadOnly,
  membership,
  possibleKinds,
  showIntegrationErrors,
  conferenceOrganizer
}) => {
  const {
    sortedLocations
  } = useLocationManagement(eventType, membership);
  const ariaLabelForIndex = index => sortedLocations.length > 1 ? `${I18n.t('publisher.event_types.location.location')}${index + 1}` : I18n.t('publisher.event_types.location.location');
  return <Wrapper>
      {isReadOnly && !sortedLocations.length && <BodyText>{I18n.t('publisher.event_type_editor.sections.event_details.location.no_location')}</BodyText>}
      {sortedLocations.map((location, index) => <SelectedLocationBase key={location.id || location.nanoId} location={location} membership={membership} aria-label={ariaLabelForIndex(index)} isDisabled={isDisabled} isLocked={isLocked} isReadOnly={isReadOnly} eventType={eventType} showIntegrationErrors={showIntegrationErrors} possibleKinds={possibleKinds} conferenceOrganizer={conferenceOrganizer} />)}
    </Wrapper>;
};

require("./location_list.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./location_list.js");